export default __webpack_public_path__ + "static/desktop_menu_KV03-49616392562976798d3394e9316dd6ed.mp4";